// Ticket 863: één voortgangslijn met het totale trainingsvolume per afgesloten
// training binnen het schema. Stijging kleurt groen, daling rood (per punt),
// met de waarde boven elk punt en de trainingsdatum + trainingsletter (A/B)
// onder de as. De tooltip toont datum, trainingsnaam, volume en het verschil
// met de vorige training.
import { Controller } from "stimulus"
import ApexCharts from 'apexcharts'

export default class extends Controller {
  static values = {
    data: Object
  }

  connect() {
    const points = this.dataValue.points || []
    const volumes = points.map(p => p.volume)
    const fmt = v => v.toLocaleString('nl-NL', { maximumFractionDigits: 0 })

    // per punt: groen wanneer gelijk of hoger dan de vorige training, rood bij daling
    const markerColors = volumes.map((v, i) => (i > 0 && v < volumes[i - 1]) ? '#DC2626' : '#16A34A')

    const options = {
      series: [{ name: "Totaal trainingsvolume (kg)", data: volumes }],
      chart: {
        height: 300,
        type: 'line',
        background: 'transparent',
        foreColor: '#6B7280',
        zoom: { enabled: false },
        toolbar: { show: false },
        animations: { enabled: true, easing: 'easeinout', speed: 500 }
      },
      colors: ['#16A34A'],
      stroke: { width: 3, curve: 'straight' },
      markers: {
        size: 5,
        strokeWidth: 2,
        strokeColors: '#ffffff',
        discrete: markerColors.map((color, i) => ({
          seriesIndex: 0, dataPointIndex: i, fillColor: color, strokeColor: '#ffffff', size: 5
        })),
        hover: { size: 7 }
      },
      dataLabels: {
        enabled: true,
        offsetY: -8,
        formatter: fmt,
        style: { colors: ['#374151'], fontSize: '11px', fontWeight: 600 },
        background: { enabled: false }
      },
      grid: {
        borderColor: '#E5E7EB',
        strokeDashArray: 4,
        padding: { top: 12, right: 16, bottom: 0, left: 8 }
      },
      xaxis: {
        categories: points.map(p => [p.date || "", p.label || ""]),
        labels: { style: { colors: '#6B7280', fontSize: '11px' } },
        axisBorder: { show: false },
        axisTicks: { show: false },
        tooltip: { enabled: false }
      },
      yaxis: {
        min: 0,
        forceNiceScale: true,
        labels: { formatter: v => `${fmt(v)} kg`, style: { colors: '#9CA3AF' } }
      },
      legend: { show: false },
      tooltip: {
        custom: ({ dataPointIndex }) => {
          const p = points[dataPointIndex]
          if (!p) return ""
          const prev = dataPointIndex > 0 ? points[dataPointIndex - 1] : null
          let diff = ""
          if (prev && prev.volume > 0) {
            const delta = p.volume - prev.volume
            const pct = ((delta / prev.volume) * 100).toFixed(1).replace(".", ",")
            const cls = delta >= 0 ? "color:#16A34A" : "color:#DC2626"
            diff = `<div style="${cls}">${delta >= 0 ? "+" : ""}${fmt(delta)} kg (${delta >= 0 ? "+" : ""}${pct}%) t.o.v. vorige</div>`
          }
          return `<div style="padding:8px 10px;font-size:12px">
            <div style="font-weight:700">${p.fullDate} – ${p.name || ("Training " + p.label)}</div>
            <div>Totaal trainingsvolume: <strong>${fmt(p.volume)} kg</strong></div>
            ${diff}
          </div>`
        }
      }
    }

    this.chart = new ApexCharts(this.element, options)
    this.chart.render()
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }
}
